export default __webpack_public_path__ + "c748aa35a35aefece4475fd921190c2a.png";